import styled, { keyframes } from 'styled-components';

// 애니메이션 정의
const blinkOpen = keyframes`
  0%, 50% { opacity: 1; }
  50%, 100% { opacity: 0; }
`;

const blinkClosed = keyframes`
  0%, 50% { opacity: 0; }
  50%, 100% { opacity: 1; }
`;

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 200px;
  padding: 324px 0;
  gap: 20px;
  background-color: #0d1117;
  border-radius: 24px;
`;

// 태양 캐릭터 래퍼
export const CharacterWrapper = styled.div`
  position: relative;
  width: 136px;
  height: 136px;
`;

// 태양 배경 (회전)
export const SunBackground = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  animation: ${rotate} 5s linear infinite;
`;

// 눈 공통 스타일
const FaceBase = styled.img`
  position: absolute;
  left: 32px;
  top: 42px;
  width: 71px;
  height: 42px;
  object-fit: cover;
`;

// 눈 감은 상태
export const FaceClosed = styled(FaceBase)`
  opacity: 0;
  animation: ${blinkClosed} 0.5s steps(1) infinite;
`;

// 눈 뜬 상태
export const FaceOpen = styled(FaceBase)`
  animation: ${blinkOpen} 0.5s steps(1) infinite;
`;

// 로딩 텍스트
export const LoadingText = styled.div`
  font-family: 'Aggro', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.36px;
  color: #ffffff;
  text-align: center;

  p {
    margin: 0;
  }
`;
